import { useActiveOrganization } from "@hooks/useActiveOrganization";
import { GroupedIntegrationsTable } from "./GroupedIntegrationsTable";
import styles from "./IntegrationsPage.module.scss";

export const IntegrationsPage = () => {
    const organization = useActiveOrganization();
    const organizationId = organization?.id ?? "";

    return (
        <div className={styles.container}>
            <GroupedIntegrationsTable organizationId={organizationId} />
        </div>
    );
};
